// import React from "react";
// import { FaCheck } from "react-icons/fa6";
// import formateText from "../../../../utils/Formate";
// const VerticalProgressBar = () => {
//   return (
//     <div className=" relative text-gray-700 flex flex-col lg:flex-row justify-center gap-9 items-start">
//       <div className='lg:w-[84%]  h-[735px] lg:h-0 top-0 left-[85px]  border-l-2 lg:border-t-2 border-black absolute lg:top-[55px] lg:left-[120px] z-10'></div>
//       {/* single steps. */}
//       <div className="flex justify-center text-center flex-row lg:flex-col lg:items-center items-start gap-3 bg-transparent">
//         <div className=" font-semibold text-lg text-center flex gap-2 flex-col lg:w-max w-[60px]">
//           May 22 18:52
//         </div>
//         <div className="w-[30px] h-[30px] relative z-20 rounded-full bg-blue-600 text-white flex justify-center items-center text-xl">
//           <FaCheck />
//         </div>
//         <div className="font-semibold text-sm w-[260px] lg:w-auto ">
//           <h1 className="text-xl font-bold h-[60px]">Delivered</h1>
//           <p className="mt-3 w-[max-content]">
//             Your package has been delivered.
//           </p>
//           <button className="text-blue-600">Tap here to share a review</button>
//           <h1 className=" font-bold text-black">[Thakurgaon]</h1>
//         </div>
//       </div>
//       <div className="flex justify-center text-center flex-row lg:flex-col lg:items-center items-start gap-3 ">
//         <div className=" font-semibold text-lg  text-center lg:w-max w-[60px]">May 22 18:29</div>
//         <div className="w-[30px] h-[30px] rounded-full relative z-20 bg-gray-400"></div>
//         <div className="font-semibold text-sm w-[260px] lg:w-auto">
//           <h1 className="text-xl font-bold h-[60px]">Out for Delivery</h1>
//           <p className="mt-3">
//             {formateText("Our delivery partner BD-DEX will attempt to deliver your package today")} <span className=" font-bold">{formateText("[Thakurgaon]")}</span>
//           </p>
//         </div>
//       </div>
//       <div className="flex justify-center text-center flex-row lg:flex-col lg:items-center items-start gap-3">
//         <div className=" font-semibold text-lg text-center lg:w-max w-[60px]">May 12 17:29</div>
//         <div className="w-[30px] h-[30px] rounded-full relative z-20 bg-gray-400"></div>
//         <div className="font-semibold text-sm w-[260px] lg:w-auto">
//           <h1 className="text-xl font-bold h-[60px]">Shipped</h1>
//           <p className="mt-3">
//             {formateText("Your package is on the way to our last mile hub with tracking number DEX-BDN-CB-2205478 from where to will be delivered to you [Dhaka - North]")}
//           </p>
//           <h1 className=" font-bold text-black">[Thakurgaon]</h1>
//         </div>
//       </div>
//       <div className="flex justify-center text-center flex-row lg:flex-col lg:items-center items-start gap-3">
//         <div className=" font-semibold text-lg text-center lg:w-max w-[60px]">May 6 9:29</div>
//         <div className="w-[30px] h-[30px] rounded-full relative z-20 bg-gray-400"></div>
//         <div className=" font-semibold text-sm w-[260px] lg:w-auto">
//           <h1 className="text-xl font-bold h-[60px] ">
//             {formateText("Riched our Logistics Facility")}
//           </h1>
//           <p className="mt-3">
//           {formateText("Your package has arrived at our logistic facility from where it willbe sent to the last mile hub")}
            
//             <span className=" font-bold text-black">[Dhaka - North]</span>
//           </p>
//         </div>
//       </div>
//       <div className="flex justify-center text-center flex-row lg:flex-col lg:items-center items-start gap-3">
//         <div className=" font-semibold text-lg text-center lg:w-max w-[60px]">May 20 18:29</div>
//         <div className="w-[30px] h-[30px] rounded-full relative z-20 bg-gray-400"></div>
//         <div className=" font-semibold text-sm w-[260px] lg:w-auto">
//           <h1 className="text-xl font-bold h-[60px]">
//             Handover To Delivery Partner
//           </h1>
//           <p className="mt-3">
//             {formateText("Your package is being sent to our warehouse from where it'll be shipped to you.")}
//           </p>
//         </div>
//       </div> 
//     </div>
//   );
// };

// export default VerticalProgressBar;


// import React from "react";
// import { FaCheck } from "react-icons/fa6";
// import formateText from "../../../../utils/Formate";

// const VerticalProgressBar = ({ 
//   statusData, 
//   loading, 
//   currentStatus,
//   routeName,
//   parcelNo
// }) => {
//   if (!parcelNo) {
//     return (
//       <div className="text-center py-8 text-gray-500">
//         Select a parcel to view its status timeline
//       </div>
//     );
//   }

//   if (loading) {
//     return (
//       <div className="text-center py-8">
//         Loading parcel status information...
//       </div>
//     );
//   }

//   if (!statusData || statusData.length === 0) {
//     return (
//       <div className="text-center py-8 text-gray-500">
//         No status information available for this parcel
//       </div>
//     );
//   }

//   // Sort statuses by rank
//   const sortedStatuses = [...statusData].sort((a, b) => a.rank - b.rank);

//   // Find the current status rank
//   const currentStatusRank = sortedStatuses.find(
//     status => status.parcelStatusName === currentStatus
//   )?.rank || 0;

//   return (
    
//     <div className="relative text-gray-700 flex flex-col lg:flex-row justify-center gap-9 items-start">
//       {/* Route Name Display */}
//          <div className="mb-5" style={{ position: 'absolute', left: '10px' }}>
//         <h2 className="text-xl font-bold">Route: {routeName || "Unknown Route"}</h2>
//         <p className="text-sm text-gray-500">Parcel ID: {parcelNo}</p>
//         {/* <p className="text-sm text-blue-600 font-medium">
//           Current Status: {currentStatus}
//         </p> */}
//       </div>
//       {/* Main connecting line */}
//       <div className='lg:w-[84%] h-[735px] lg:h-0 top-0 left-[85px] border-l-2 lg:border-t-2 border-black absolute lg:top-[55px] lg:left-[120px] z-10'></div>
      
//       {/* Status items */}
//       {sortedStatuses.map((status) => {
//         const isCompleted = status.rank < currentStatusRank;
//         const isCurrent = status.rank === currentStatusRank;
        
//         // Generate a sample date based on rank (replace with actual dates if available)
//         const sampleDate = new Date();
//         sampleDate.setDate(sampleDate.getDate() - (sortedStatuses.length - status.rank));
//         const formattedDate = sampleDate.toLocaleDateString('en-US', {
//           month: 'short',
//           day: 'numeric',
//           year: 'numeric',
//           hour: '2-digit',
//           minute: '2-digit'
//         }).replace(',', '');

//         return (
//           <div 
//             key={status.rank} 
//             className="flex justify-center text-center flex-row lg:flex-col lg:items-center items-start gap-3 bg-transparent"
//           >
//             {/* Date */}
//             <div className="font-semibold text-lg text-center flex gap-2 flex-col lg:w-max w-[60px]">
//               {/* {formattedDate} */}
//               Status {status.rank}
//             </div>
            
//             {/* Status indicator */}
//             <div className={`w-[30px] h-[30px] relative z-20 rounded-full 
//               ${isCurrent ? 'bg-blue-600' : isCompleted ? 'bg-gray-600' : 'bg-gray-400'} 
//               text-white flex justify-center items-center text-xl`}
//             >
//               {(isCurrent || isCompleted) && <FaCheck />}
//             </div>
            
//             {/* Status details */}
//             <div className="font-semibold text-sm w-[260px] lg:w-auto">
//               <h1 className="text-xl font-bold h-[60px]">
//                 {status.parcelStatusName}
//               </h1>
//               <p className="mt-3 w-[max-content]">
//                 {getStatusDescription(status.parcelStatusName)}
//                 <span className="font-bold text-black"> [{routeName}]</span>
//               </p>
//               {isCurrent && (
//                 <button className="text-blue-600">Tap here to share a review</button>
//               )}
//             </div>
//           </div>
//         );
//       })}
//     </div>
//   );
// };

// // Helper function for status descriptions
// const getStatusDescription = (statusName) => {
//   const descriptions = {
//     "Dropped at HUB": "Your package has been received at our processing facility",
//     "Way to airport": "Your package is en route to the airport for shipping",
//     "Delivered": "Your package has been delivered",
//     "Out for Delivery": "Our delivery partner will attempt to deliver your package today",
//     "Shipped": "Your package is on the way to our last mile hub",
//     "Riched our Logistics Facility": "Your package has arrived at our logistic facility",
//     "Handover To Delivery Partner": "Your package is being sent to our warehouse",
//   };
  
//   return descriptions[statusName] || `Status: ${statusName}`;
// };

// export default VerticalProgressBar;




import React from "react";
import {
  FaCheck,
  FaBoxOpen,
  FaPlane,
  FaTruck,
  FaHome,
} from "react-icons/fa";
import { GiDeliveryDrone } from "react-icons/gi";
import { IoMdTime } from "react-icons/io";

const statusIcons = {
  "Dropped at HUB": <FaBoxOpen />,
  "Way to airport": <FaPlane />,
  "Delivered": <FaHome />,
  "Out for Delivery": <FaTruck />,
  "Shipped": <GiDeliveryDrone />,
  "Reached our Logistics Facility": <FaBoxOpen />,
  "Handover To Delivery Partner": <FaTruck />,
};

const VerticalProgressBar = ({
  statusData,
  loading,
  currentStatus,
  routeName,
  parcelNo,
  embedded = false,
}) => {
  if (!parcelNo) {
    return (
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-4">
          <IoMdTime className="text-4xl text-gray-400" />
        </div>
        <h3 className="text-xl font-semibold text-gray-600 mb-2">
          No Parcel Selected
        </h3>
        <p className="text-gray-500 max-w-md">
          Please select a parcel to view its detailed status timeline and tracking information
        </p>
      </div>
    );
  }

  if (loading) {
    return (
      <div
        className={`flex flex-col items-center justify-center text-center ${
          embedded ? "py-6" : "py-12"
        }`}
      >
        <div className="animate-pulse w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-3">
          <div className="w-8 h-8 bg-blue-200 rounded-full"></div>
        </div>
        <h3 className="text-base font-semibold text-gray-600 mb-1">
          Tracking your package
        </h3>
        <p className="text-sm text-gray-500">Gathering the latest status…</p>
      </div>
    );
  }

  if (!statusData || statusData.length === 0) {
    return (
      <div
        className={`flex flex-col items-center justify-center text-center ${
          embedded ? "py-6" : "py-12"
        }`}
      >
        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-3">
          <FaBoxOpen className="text-2xl text-gray-400" />
        </div>
        <h3 className="text-base font-semibold text-gray-600 mb-1">
          No tracking data available
        </h3>
        <p className="text-sm text-gray-500 max-w-md">
          No status timeline found for parcel {parcelNo}.
        </p>
      </div>
    );
  }

  const sortedStatuses = [...statusData].sort((a, b) => a.rank - b.rank);
  const currentStatusRank =
    sortedStatuses.find((s) => s.parcelStatusName === currentStatus)?.rank || 0;

  return (
    <div
      className={
        embedded
          ? "bg-white rounded-lg border border-stone-200 p-4 min-w-0 overflow-hidden"
          : "bg-white rounded-xl shadow-md p-6"
      }
    >
      {/* Header */}
      <div className={`border-b pb-3 ${embedded ? "mb-4" : "mb-8 pb-4"}`}>
        <div className="flex flex-wrap items-center justify-between gap-2 min-w-0">
          <div className="min-w-0">
            <h2
              className={`font-bold text-gray-800 break-words ${
                embedded ? "text-lg" : "text-2xl"
              }`}
            >
              {routeName || "Shipment tracking"}
            </h2>
            <p className="text-sm text-gray-500">Tracking #: {parcelNo}</p>
          </div>
          {currentStatus ? (
            <div className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium max-w-full break-words">
              {currentStatus}
            </div>
          ) : null}
        </div>
      </div>

      {/* Horizontal Status Timeline
      <div className="relative overflow-x-auto pb-6">
        <div className="flex items-center space-x-8 min-w-max relative">
          {sortedStatuses.map((status, index) => {
            const isCompleted = status.rank < currentStatusRank;
            const isCurrent = status.rank === currentStatusRank;
            const isLast = index === sortedStatuses.length - 1;

            return (
              <div className="flex flex-col items-center text-center" key={status.rank}>

                {index !== 0 && (
                  <div className="absolute top-5 h-1 bg-gray-300 z-0"
                    style={{
                      left: `${index * 120 - 60}px`,
                      width: `120px`,
                    }}
                  ></div>
                )}

                <div className={`relative z-10 w-10 h-10 rounded-full flex items-center justify-center mb-2
                  ${isCurrent ? "bg-blue-600 ring-4 ring-blue-200" :
                    isCompleted ? "bg-green-500" : "bg-gray-300"}
                  text-white`}
                >
                  {isCompleted || isCurrent ? (
                    <FaCheck className="text-sm" />
                  ) : (
                    statusIcons[status.parcelStatusName] || <FaBoxOpen />
                  )}
                </div>

                <p className={`text-sm font-medium ${
                  isCurrent ? "text-blue-600" :
                  isCompleted ? "text-green-600" : "text-gray-500"
                }`}>
                  {status.parcelStatusName}
                </p>
              
              </div>
            );
          })}
        </div>
      </div> */}


      {/* Horizontal Status Timeline */}
{/* <div className="relative overflow-x-auto pb-6">
  <div className="grid grid-cols-8 w-full gap-x-2 relative">
    {sortedStatuses.map((status, index) => {
      const isCompleted = status.rank < currentStatusRank;
      const isCurrent = status.rank === currentStatusRank;

      return (
        <div
          className="flex flex-col items-center text-center relative"
          key={status.rank}
        >

          {index !== 0 && (
            <div className="absolute -left-[50%] top-6 h-1 w-full bg-gray-300 z-0"></div>
          )}

          <div
            className={`relative z-10 w-16 h-16 rounded-full flex items-center justify-center mb-2 text-xl
              ${isCurrent ? "bg-blue-600 ring-4 ring-blue-200" :
                isCompleted ? "bg-green-500" : "bg-gray-300"}
              text-white`}
          >
            {isCompleted || isCurrent ? (
              <FaCheck />
            ) : (
              statusIcons[status.parcelStatusName] || <FaBoxOpen />
            )}
          </div>

          <p
            className={`text-sm font-medium px-1 ${
              isCurrent ? "text-blue-600" :
              isCompleted ? "text-green-600" : "text-gray-500"
            }`}
          >
            {status.parcelStatusName}
          </p>
        </div>
      );
    })}
  </div>
</div>
 */}
 <div className="relative overflow-x-auto pb-6">
  <div className="flex gap-8 min-w-[600px] sm:min-w-full px-4">
    {sortedStatuses.map((status, index) => {
      const isCompleted = status.rank < currentStatusRank;
      const isCurrent = status.rank === currentStatusRank;

      return (
        <div
          className="flex flex-col items-center text-center min-w-[80px] relative"
          key={status.rank}
        >
          {/* Connector line */}
          {index !== 0 && (
            <div className="absolute top-8 -left-[50%] w-[100%] h-[2px] bg-gray-300 z-0"></div>
          )}

          <div
            className={`relative z-10 w-12 h-12 sm:w-16 sm:h-16 rounded-full flex items-center justify-center mb-2 text-lg sm:text-xl
              ${isCurrent ? "bg-blue-600 ring-4 ring-blue-200" :
                isCompleted ? "bg-green-500" : "bg-gray-300"}
              text-white`}
          >
            {isCompleted || isCurrent ? (
              <FaCheck />
            ) : (
              statusIcons[status.parcelStatusName] || <FaBoxOpen />
            )}
          </div>

          <p
            className={`text-xs sm:text-sm font-medium px-1 ${
              isCurrent ? "text-blue-600" :
              isCompleted ? "text-green-600" : "text-gray-500"
            }`}
          >
            {status.parcelStatusName}
          </p>
        </div>
      );
    })}
  </div>
</div>


      {/* Delivery Estimate */}
      {/* <div className="mt-6 bg-gray-50 p-4 rounded-lg border border-gray-200">
        <div className="flex items-center">
          <div className="bg-blue-100 p-2 rounded-full mr-3">
            <FaTruck className="text-blue-600" />
          </div>
          <div>
            <h4 className="font-medium text-gray-800">Estimated Delivery</h4>
            <p className="text-sm text-gray-600">
              {currentStatus === "Delivered"
                ? "Package was delivered successfully"
                : "Expected by Friday, May 24"}
            </p>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default VerticalProgressBar;
